import { Employee } from "../assignments/types";

export type InventoryCategory = 'Hardware' | 'Software' | 'Digital Asset' | 'Gift' | 'Other';

export type InventoryStatus = 'Available' | 'Assigned' | 'Sold' | 'Retired';

export type PaymentType = 'One Time' | 'Recursive';

export type PaymentCadence = 'Monthly' | 'Quarterly' | 'Yearly' | 'Custom';

export type InventoryEventType = 'Created' | 'Assigned' | 'Unassigned' | 'Sold' | 'Retired' | 'Edited';

export type PurchaseRequestStatus = 'Pending' | 'Approved' | 'Rejected' | 'Purchased' | 'Adjusted';

export const inventoryCategoryOptions = [
  { label: 'Hardware', value: 'Hardware' },
  { label: 'Software', value: 'Software' },
  { label: 'Digital Asset', value: 'Digital Asset' },
  { label: 'Gift', value: 'Gift' },
  { label: 'Other', value: 'Other' }
];

export const inventoryStatusOptions = [
  { label: 'Available', value: 'Available' },
  { label: 'Assigned', value: 'Assigned' },
  { label: 'Sold', value: 'Sold' },
  { label: 'Retired', value: 'Retired' }
];

export const paymentTypeOptions = [
  { label: 'One Time', value: 'One Time' },
  { label: 'Recursive', value: 'Recursive' }
];

export const paymentCadenceOptions = [
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Yearly', value: 'Yearly' },
  { label: 'Custom', value: 'Custom' }
];

export const purchaseRequestStatusOptions = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Approved', value: 'Approved' },
  { label: 'Rejected', value: 'Rejected' },
  { label: 'Purchased', value: 'Purchased' },
  { label: 'Adjusted', value: 'Adjusted' }
];

export interface InventoryItem {
  id: string;
  name: string;
  serial: string;
  description: string | null;
  category: InventoryCategory;
  cost: number | null;
  currency: string;
  purchase_date: string | null;
  authorized_by: number | null;
  status: InventoryStatus;
  assignee_id: number | null;
  location: string | null;
  status_changed_at: string;
  created_at: string;
  updated_at: string | null;
  payment_type: PaymentType;
  payment_cadence: PaymentCadence | null;
  next_payment_date: string | null;
  payment_amount: number | null;
  assignee_name?: string | null;
  authorizer_name?: string | null;
}

export interface InventoryItemHistory {
  id: string;
  item_id: string;
  event_type: InventoryEventType;
  actor_id: number | null;
  details: any;
  event_at: string;
  actor_name?: string | null;
}

export interface PurchaseRequest {
  id: string;
  requested_by: number;
  description: string | null;
  justification: string | null;
  estimated_cost: number | null;
  currency: string;
  category: InventoryCategory;
  status: PurchaseRequestStatus;
  approved_by: number | null;
  approved_at: string | null;
  inventory_item_id: string | null;
  created_at: string;
  actual_cost: number | null;
  payment_type: PaymentType | null;
  payment_cadence: PaymentCadence | null;
  next_payment_date: string | null;
  payment_amount: number | null;
  requester_name?: string | null;
  approver_name?: string | null;
}

export interface StorageLocation {
  id: string;
  name: string;
}

export function getInventoryStatusColor(status: InventoryStatus): string {
  switch (status) {
    case 'Available':
      return 'bg-green-100 text-green-700';
    case 'Assigned':
      return 'bg-blue-100 text-blue-700';
    case 'Sold':
      return 'bg-rose-100 text-rose-700';
    case 'Retired':
      return 'bg-gray-100 text-gray-700';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}

export function getInventoryStatusIcon(status: InventoryStatus) {
  switch (status) {
    case 'Available':
      return 'available';
    case 'Assigned':
      return 'assigned';
    case 'Sold':
      return 'sold';
    case 'Retired':
      return 'retired';
    default:
      return 'help';
  }
}

export function getPurchaseRequestStatusColor(status: PurchaseRequestStatus): string {
  switch (status) {
    case 'Pending':
      return 'bg-amber-100 text-amber-700';
    case 'Approved':
      return 'bg-green-100 text-green-700';
    case 'Rejected':
      return 'bg-red-100 text-red-700';
    case 'Purchased':
      return 'bg-blue-100 text-blue-700';
    case 'Adjusted':
      return 'bg-purple-100 text-purple-700';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}

export function isRecursivePayment(item: InventoryItem | PurchaseRequest): boolean {
  return item.payment_type === 'Recursive';
}
